import ContainerWidget from "../../../widgets/ContainerWidget/widget";
import {WidgetType} from "../../../constants/WidgetConstants";

class AtContainerWidget extends ContainerWidget{
  static getWidgetType(): WidgetType {
    return "AT_CONTAINER_WIDGET";
  }
}
export default AtContainerWidget;
